<script lang="ts">
    import { newNotification, removeNotification, login } from "../../../store"
    import { updatePriceCalculation, createPriceCalculation, deletePriceCalculation } from "../../../api"
    import Icon from "../../widgets/Icon.svelte"
    import { mdiChevronUp } from "@mdi/js"
    import { createEventDispatcher } from "svelte"
    import { mdiPencil, mdiTrashCan } from "@mdi/js"
    import { tooltip } from "../../../helper"
    import PricecalcFields from "./PricecalcFields.svelte"
    import hash from "object-hash"
    import { _ } from "svelte-i18n"
    export let global = false
    const emptyDefaultCalc: PriceCalculation = {
        id: null,
        daysValid: null,
        dealerNumber: null,
        groupName: global ? null : "",
        expiryDates: [],
        calculation: {
            discountPercent: null,
            surchargePercent: null,
            type: "surcharge",
        },
        exception: { rules: [] },
        ruleBasedCalculation: [],
        vat: null,
        globalCalculation: null,
    }
    export let priceCalculation: PriceCalculation = JSON.parse(JSON.stringify(emptyDefaultCalc))

    let priceCalculationCopy = JSON.parse(JSON.stringify(priceCalculation))

    let notification: NotificationEntry
    let inProgress: boolean = false
    $: loginData = $login

    $: if (priceCalculation && !priceCalculation.ruleBasedCalculation) {
        priceCalculation.ruleBasedCalculation = []
    }

    const updatePricingForm = () => {
        removeNotification(notification)
        inProgress = true

        if (ruleWithoutFilter && priceCalculation.exception && priceCalculation.exception.rules) {
            priceCalculation.exception.rules = priceCalculation.exception.rules.filter(
                (r) => r && r.filter && r.filter.length > 0
            )
        }

        if (priceCalculation.id) {
            updatePriceCalculation(priceCalculation)
                .then((e) => {
                    priceCalculation = e.data
                    dispatch("refresh", e.data)
                    notification = newNotification({
                        class: "success",
                        html: $_("components.pcalc.updateSuccess"),
                        timeout: 3000,
                        removeOnNewLocation: true,
                    })
                    priceCalculationCopy = JSON.parse(JSON.stringify(priceCalculation))
                    if (!global) open = false
                })
                .catch((e) => {
                    newNotification({
                        class: "error",
                        html: $_("components.pcalc.updateError"),
                        timeout: 3000,
                        removeOnNewLocation: true,
                    })
                })
                .finally(() => {
                    inProgress = false
                    if (priceCalculation) pricecalcHash = hash(priceCalculation)
                })
        } else {
            priceCalculation.dealerNumber = loginData?.account?.ident?.dealerNumber

            createPriceCalculation(priceCalculation)
                .then((e) => {
                    priceCalculation = e.data
                    dispatch("refresh", e.data)
                    notification = newNotification({
                        class: "success",
                        html: $_("components.pcalc.createSuccess"),
                        timeout: 3000,
                        removeOnNewLocation: true,
                    })
                    priceCalculationCopy = JSON.parse(JSON.stringify(priceCalculation))
                    if (!global) open = false
                })
                .catch((e) => {
                    newNotification({
                        class: "error",
                        html: $_("components.pcalc.createError"),
                        timeout: 3000,
                        removeOnNewLocation: true,
                    })
                })
                .finally(() => {
                    inProgress = false
                    priceCalculationChanged = false
                    if (priceCalculation) pricecalcHash = hash(priceCalculation)
                })
        }

        inProgress = false
    }
    const deletePricingCalc = () => {
        inProgress = true
        if (!priceCalculation.id) {
            dispatch("remove")
            return
        }
        deletePriceCalculation(priceCalculation)
            .then((res) => {
                notification = newNotification({
                    class: "success",
                    html: $_("components.pcalc.deleteSuccess"),
                    timeout: 3000,
                    removeOnNewLocation: true,
                })
                dispatch("remove")
            })
            .catch((e) => {
                newNotification({
                    class: "error",
                    html: $_("components.pcalc.deleteError"),
                    timeout: 3000,
                    removeOnNewLocation: true,
                })
                console.error(e)
            })
            .finally(() => {
                inProgress = false
            })
    }
    const submit = () => {
        updatePricingForm()
    }

    let dispatch = createEventDispatcher()
    let input: HTMLElement
    let open = global

    let pricecalcHash = hash(priceCalculation)
    let priceCalculationChanged = false

    $: if (priceCalculation && hash(priceCalculation) === pricecalcHash) priceCalculationChanged = false
    else priceCalculationChanged = true

    $: ruleWithoutFilter =
        priceCalculation.exception?.rules?.filter((r) => r && (!r.filter || r.filter?.length === 0))?.length > 0
</script>

<style lang="less">
</style>

<form on:submit|preventDefault="{submit}" class:show="{open}" name="{global ? 'globalPCalc' : 'pricegroups'}">
    <div class="{global ? 'section-title' : 'group-title-container'}">
        {#if global}
            {$_("components.pcalc.defaultCalculation")}
        {:else}
            <!-- svelte-ignore a11y-click-events-have-key-events -->
            <!-- svelte-ignore a11y-no-static-element-interactions -->
            <div
                style="display: flex; justify-content: space-between; cursor: pointer;"
                class="group-title"
                on:click="{() => {
                    open = !open
                }}"
            >
                <!-- svelte-ignore a11y-no-static-element-interactions -->
                <div class="group-title-field" on:click|stopPropagation on:keydown>
                    <input
                        size="{priceCalculation.groupName.length}"
                        placeholder="{$_('components.pcalc.groupNamePlaceholder')}"
                        data-cy="group-name"
                        bind:this="{input}"
                        bind:value="{priceCalculation.groupName}"
                        required="{!global ? true : false}"
                        on:focus="{() => (open = true)}"
                    />

                    <div class="actions">
                        <button
                            class="btn btn-link"
                            data-cy="edit-group-name"
                            on:click|preventDefault|stopPropagation="{() => input.focus()}"
                            use:tooltip="{{ content: $_('components.pcalc.editGroupName') }}"
                        >
                            <Icon path="{mdiPencil}" size="24px" />
                        </button>
                        <button
                            class="btn btn-link delete-cart"
                            on:click|preventDefault|stopPropagation="{() => {
                                deletePricingCalc()
                            }}"
                            use:tooltip="{{ content: $_('components.pcalc.deleteGroup') }}"
                            data-cy="delete-group"
                        >
                            <Icon path="{mdiTrashCan}" size="24px" />
                        </button>
                    </div>
                </div>
                <!-- svelte-ignore a11y-no-static-element-interactions -->
                <div
                    class="chevron"
                    class:open
                    data-cy="toggle-group"
                    on:click|stopPropagation="{() => {
                        open = !open
                    }}"
                >
                    <Icon path="{mdiChevronUp}" size="42px" />
                </div>
            </div>
        {/if}
    </div>
    <PricecalcFields bind:priceCalculation />

    <section class="layout justify-content-end layout-gap-md mt-md mb-xl">
        {#key priceCalculationChanged}
            <div style="display: flex; flex-direction: column; position: relative;">
                {#if priceCalculationChanged || !priceCalculation.id}
                    <button
                        type="button"
                        data-cy="cancel"
                        use:tooltip="{{
                            content: $_('components.pcalc.resetTooltip'),
                        }}"
                        style="border: 0px; padding: 0px; background: transparent; position: absolute; top: -20px;"
                        on:click="{() => {
                            if (!priceCalculation.id) {
                                // empty default
                                priceCalculation = JSON.parse(JSON.stringify(emptyDefaultCalc))
                                priceCalculationCopy = JSON.parse(JSON.stringify(priceCalculation))
                            } else {
                                priceCalculation = JSON.parse(JSON.stringify(priceCalculationCopy))
                                pricecalcHash = hash(priceCalculationCopy)
                            }
                            priceCalculationChanged = false
                        }}"
                    >
                        ⟳ {$_("components.pcalc.reset")}
                    </button>
                {/if}
                <div
                    use:tooltip="{{
                        content:
                            priceCalculationChanged || !priceCalculation.id
                                ? ruleWithoutFilter
                                    ? $_('general.exceptionWithoutFilter')
                                    : 'invalid'
                                : $_('components.pcalc.notModified'),
                    }}"
                >
                    <button type="submit" class="btn" disabled="{!(priceCalculationChanged || !priceCalculation.id)}"
                        >{$_("general.save")}</button
                    >
                </div>
            </div>
        {/key}
    </section>
</form>
